import { SlotParams, SlotParamsDeclaration } from '../models/SlotParams';
import { isServer }                          from '../../utils';

class IsomorphicSlotParams {
    public params: SlotParams | any = {};

    constructor() {
        if (!isServer) {
            this.params = (window as any).__SLOT_SERVER_PARAMS__ || {};
        } else {
            const slot = process.env.APP_SLOT || 'prod';
            console.log(`DEBUG APP_SLOT:${slot}`);
            // Then it will be printed to html as __SLOT_SERVER_PARAMS__
            this.params = SlotParamsDeclaration[slot];
        }
    }

    isProd() {
        return this.params.SLOT === 'prod';
    }

    isStage() {
        return this.params.SLOT === 'stage';
    }
}

export const SlotParamsService = new IsomorphicSlotParams();
